module.exports = __webpack_public_path__ + "img/logo8.8fae5392.png";